import { createContext, MiddlewareFunction, redirect } from 'react-router-dom'
import { auth } from '../firebase/configs'
import { User } from 'firebase/auth'

export const authContext = createContext<User | null>()

export const authMiddleware: MiddlewareFunction = async ({ context }) => {
    await auth.authStateReady()

    let user = auth.currentUser ? (auth.currentUser.toJSON() as User) : null
    if (user === null) {
        throw redirect('/login')
    }
    context.set(authContext, user)
}

export const deleteAuthMiddleware: MiddlewareFunction = async () => {
    await auth.authStateReady()

    if (auth.currentUser === null) {
        throw redirect('/')
    }
}
